// src/hooks/useTareasManuales.js
import { useState, useEffect } from "react";
import {
  collection, setDoc, updateDoc, deleteDoc,
  doc, onSnapshot, query, orderBy, serverTimestamp,
} from "firebase/firestore";
import { db } from "../firebase";

const COL = "tareasManuales";

// Tareas agregadas a mano en Mi Día — antes vivían solo en useState (se perdían
// al refrescar la página, ni siquiera llegaban a localStorage). Ahora persisten
// en Firestore para sobrevivir cambios de equipo/navegador.
export function useTareasManuales() {
  const [tareasManual, setTareasManual] = useState([]);
  const [loadingManual, setLoadingManual] = useState(true);

  useEffect(() => {
    const q = query(collection(db, COL), orderBy("creadoEn", "desc"));
    const unsub = onSnapshot(q, snap => {
      setTareasManual(snap.docs.map(d => ({ id: d.id, ...d.data() })));
      setLoadingManual(false);
    }, () => {
      // Fallback sin orderBy si no hay índice creado aún
      const q2 = query(collection(db, COL));
      onSnapshot(q2, snap => {
        setTareasManual(snap.docs.map(d => ({ id: d.id, ...d.data() })));
        setLoadingManual(false);
      });
    });
    return unsub;
  }, []);

  // El ID real del documento de Firestore ES el id sintético "manual_<timestamp>"
  // (setDoc, no addDoc) — así el resto de MiDia.jsx sigue distinguiendo tareas
  // manuales con tarea.id?.startsWith("manual_") sin tocar esa convención.
  const agregarTareaManual = async (datos) => {
    const id = datos.id || `manual_${Date.now()}`;
    await setDoc(doc(db, COL, id), {
      ...datos,
      completada: false,
      notaCompletado: "",
      creadoEn: serverTimestamp(),
    });
  };

  // Usado tanto para "marcar hecho" (con nota) como para "reprogramar" (sin nota) —
  // mismo comportamiento que el código anterior, que reutilizaba un solo flag para
  // ambos casos (ocultar la tarea del plan de hoy).
  const completarTareaManual = async (docId, nota = "") => {
    await updateDoc(doc(db, COL, docId), {
      completada: true,
      notaCompletado: nota,
    });
  };

  const eliminarTareaManual = async (docId) => {
    await deleteDoc(doc(db, COL, docId));
  };

  return { tareasManual, loadingManual, agregarTareaManual, completarTareaManual, eliminarTareaManual };
}
